import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useDarkMode from "../../hooks/useDarkMode";
import { guestToken, login } from "../../redux/auth/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { useSelector } from "react-redux";
// import { selectListItems as selectChannelListItems } from "../../redux/channel/selector";
import { userProfile } from "../../redux/userProfile/action";
import { useForm } from "react-hook-form";
import storePersist from "../../redux/storePersist";
import _ from "lodash";
import { toast } from "react-toastify";
import { settings } from "../../redux/settings/actions";
import EmailInput from "../../common/components/form/EmailInput.Component";
import { RotatingLines } from "react-loader-spinner";
import PasswordInput from "../../common/components/form/PasswordInput.Component";

export default function IshipXLogin() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
    const [baseURL, setBaseUrl] = useState('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [steps, setSteps] = useState({ Email: '', Password: '' })
    const [loginValues, setLoginValues] = useState<any>()
    const [selectedLoginType, setSelectedLoginType] = useState<string>(""); // dropdown
    const loginTypeRef = useRef<HTMLSelectElement | null>(null);
    const loginErrorRef = useRef<HTMLParagraphElement | null>(null);

    const [colorTheme, setTheme] = useDarkMode();
    const [darkSide, setDarkSide] = useState(
        colorTheme === "light" ? true : false
    );
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const toggleDarkMode = (checked: any) => {
        setTheme(colorTheme);
        setDarkSide(checked);
    };
    const handleSteps = (e: any, key: any) => {
        setSteps({ ...steps, [key]: e.target.value })
    }

    const handleChange: any = (event: any, field: string) => {
        setLoginValues({ ...loginValues, [field]: event })
    }



    const handleForgotPassword = (e: any) => {
        e.preventDefault();
        storePersist.set('reset-pwd', 'management')
        navigate('/login/forgot-password')
    }

    const getLoginPayload = (type: string, metaData: any) => {
        const Email = steps?.Email;
        const Password = steps?.Password;
        const OUId = metaData?.current?.items?.Website?.OUId;

        switch (type.toLowerCase()) {

            case "transporter":
                return {
                    "Records": [
                        {
                            "Context": {
                                "Domain": "Logistics",
                                "Platform": "ULIP",
                                "Application": "Transporter"
                            },
                            "Message": {
                                "Username": Email,
                                "Password": Password,
                                "AccountType": "Transporter",
                                "LoginWithOtp": false,
                                "Otp": "",
                                "IsGoogleAuthenticated": false,
                                "AuthenticatedUserId": "",
                                "ClientIPAddress": "",
                                "OrganizationUnitId": metaData?.current?.items?.Website?.OUId
                            }
                        }
                    ]
                };
            default: // management
                return {
                    "Records": [
                        {
                            "Context": {
                                "Domain": "ERP",
                                "Platform": "Management",
                                "Application": "Management",
                                "Channel": "Portal"
                            },
                            "Message": {
                                Username: Email,
                                Password: Password,
                                AccountType: "Internal",
                                LoginWithOtp: false,
                                Otp: "",
                                IsGoogleAuthenticated: false,
                                AuthenticatedUserId: "",
                                ClientIPAddress: "",
                                OrganizationUnitId: OUId
                            }
                        }
                    ]
                };
        }
    };

    const handleRoleRedirect = async (loginType: string, roles: any[]) => {
        let matchedRole = "";
        console.log(loginType, 'loginType')
        const roleMap = {
            management: ["businessowner"],
            transporter: ["transporter"],


        };

        const expectedRoles = roleMap[loginType.toLowerCase()] || roleMap["DSAPAgency"];

        roles.find((element: any) =>
            element?.Message?.Roles.find((role: any) => {
                if (expectedRoles.includes(role?.Name?.toLowerCase())) {
                    matchedRole = role.Name.toLowerCase();
                    return true;
                }
                return false;
            })
        );

        // Redirect logic
        switch (loginType.toLowerCase()) {
            case "transporter":
                return matchedRole === "transporter"
                    ? navigate("/transporter/home") : navigate("/") // Or another route for transporter

            default:
                return navigate("/management/home");
        }
    };

    const onFinish = async () => {
        if (!selectedLoginType) {
            if (loginErrorRef.current) loginErrorRef.current.style.display = "block";
            loginTypeRef.current?.focus();
            return;
        }

        setIsLoading(true);
        try {
            const metaData: any = storePersist.get("metaTokenMetaData");

            const loginType = selectedLoginType
            const loginPayload = getLoginPayload(loginType, metaData);

            await dispatch(login({ loginData: loginPayload }));

            const resp = await dispatch(userProfile.read({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/user-service/user-profile/me`,
                entity: 'userProfile'
            }));

            await handleRoleRedirect(loginType, resp);
        } catch (e: any) {
            toast.error(e?.Error?.Message || "There was an error in login. Please try again...");
            console.error("Login failed:", e?.Error?.Message);
        }
        setIsLoading(false);
    };

    const startGoogleAuthentication = () => {
        storePersist.set('google-login-role', 'businessowner')
        const guestToken = localStorage.getItem("guest-token");
        const url = `${process.env.REACT_APP_IDENTITY_SERVER_URL}/googleauth/SignInWithGoogle?guest_token=${guestToken}&ClientRedirectUrl=${baseURL}`
        window.location.href = url;
    }



    useEffect(() => {
        setBaseUrl(window.location.origin);
        clearErrors('Email')
        clearErrors('Password')
    }, [])
    const banner = require(`./../../assets/img/banner3 copy.png`)
    const logo = require(`./../../assets/img/digiit.ai.png`)
    return (
        <form onSubmit={handleSubmit(onFinish)}>
            <div className="flex min-h-screen w-screen overflow-hidden">
                {/* Left Side - Image */}
                <div className="w-1/2 hidden md:block">
                    <img
                        src={banner}
                        alt="IIMB Building"
                        className="w-full h-full object-cover"
                    />
                </div>

                {/* Right Side - Form */}
                <div className="w-full md:w-1/2 flex justify-center items-center bg-white">
                    <div className="max-w-md w-full px-6 sm:px-8">
                        {/* Logo */}
                        <div className="flex justify-center mb-6">
                            <img
                                src={logo}
                                alt="Digiit Logo"
                                className="h-10"
                            />
                        </div>

                        {/* Heading */}
                        <h2 className="text-2xl font-semibold text-center mb-6">
                            Sign in to your account
                        </h2>

                        {/* Email Field */}
                        <EmailInput
                            label="E-mail"
                            name="Email"
                            isRequired={true}
                            register={register}
                            errors={errors}
                            setValue={setValue}
                            handleSteps={(e) => handleSteps(e, "Email")}
                        />

                        {/* Password Field */}
                        <PasswordInput
                            label="Password"
                            name="Password"
                            isRequired={true}
                            register={register}
                            errors={errors}
                            setValue={setValue}
                            handleSteps={(e) => handleSteps(e, "Password")}
                        />

                        {/* Links */}
                        <div className="flex flex-col mt-2 text-sm space-y-2">
                            <a
                                href="#"
                                onClick={handleForgotPassword}
                                className="text-blue-600 hover:underline self-start"
                            >
                                Forgot password?
                            </a>

                            {/* Login Type Dropdown */}
                            <select
                                ref={loginTypeRef}
                                onChange={(e) => {
                                    setSelectedLoginType(e.target.value);
                                    if (loginErrorRef.current) loginErrorRef.current.style.display = "none";
                                }}
                                className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                defaultValue=""
                            >
                                <option value="" disabled>Select</option>
                                <option value="management">iShipX Management</option>
                                <option value="transporter">iShipX Transporter</option>


                            </select>

                            <p ref={loginErrorRef} className="text-red-600 text-sm mt-1 hidden">
                                Please select the application you want to launch.
                            </p>
                        </div>

                        {/* Submit */}

                        <button
                            type="submit"
                            disabled={isLoading}
                            className={`${isLoading ? 'bg-blue-600 bg-opacity-70' : 'bg-blue-600'
                                }  flex-row mt-6 flex items-center justify-center text-white rounded font-semibold text-xl p-4 w-full h-11`}
                        >
                            Sign in
                            <div className={` ${isLoading ? 'visible pl-2' : 'invisible'}`}>
                                <RotatingLines
                                    visible={true}
                                    width={'20'}
                                    strokeColor="#fff"
                                    strokeWidth="6"
                                    animationDuration="0.75"
                                    ariaLabel="rotating-lines-loading"
                                />
                            </div>
                        </button>



                        {/* Divider */}
                        <div className="my-4 flex items-center">
                            <hr className="flex-grow border-gray-300" />
                            <span className="mx-2 text-gray-500 text-sm">Or continue with</span>
                            <hr className="flex-grow border-gray-300" />
                        </div>

                        {/* Social Buttons */}
                        <div className="flex flex-col space-y-2">
                            <button
                                type="button"
                                className="border border-gray-300 py-2 rounded text-sm flex items-center justify-center"
                                onClick={() => {
                                    // OTP logic
                                }}
                            >
                                Sign in with OTP
                            </button>
                            <button
                                type="button"
                                onClick={startGoogleAuthentication}
                                className="border border-gray-300 py-2 rounded text-sm flex items-center justify-center"
                            >
                                Sign in with Google
                            </button>
                        </div>

                        {/* Terms */}
                        <div className="mt-4 text-xs text-center text-gray-500">
                            <p>Terms of use - Privacy policy</p>
                            <p className="mt-1">
                                This site is protected by Digiit Business Services{" "}
                                <a href="https://policies.google.com/privacy" className="underline">
                                    Privacy Policy
                                </a>{" "}
                                and{" "}
                                <a href="https://policies.google.com/terms" className="underline">
                                    Terms of Service
                                </a>{" "}
                                apply.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
}
